import { useCallback } from "react";

import { useSavePassportNumber } from "@/shared/hooks/useSavePassportNumber";
import { useSaveRegularSSN } from "@/shared/hooks/useSaveRegularSSN";
import { supabase } from "@/shared/lib/supabase";

export function useSaveCredentials(
  authUserId: number | undefined,
  deceasedUserId: number | undefined,
) {
  const { saveSSN: saveRegularSSN } = useSaveRegularSSN();
  const { savePassportNumber } = useSavePassportNumber();

  return useCallback(
    async (data: Record<string, string>) => {
      const userSSNDigits = data.user_ss_number?.replace(/\D/g, "") ?? "";
      if (userSSNDigits.length === 9 && authUserId) {
        await saveRegularSSN({ ssn: userSSNDigits, userId: authUserId });
      }

      if (deceasedUserId) {
        if (data.deceased_passport_number?.trim()) {
          await savePassportNumber({
            passportNumber: data.deceased_passport_number.trim(),
            estateId: deceasedUserId,
          });
        }

        const relationshipValue = data.user_relationship || data.relationship_to_deceased;
        if (relationshipValue && authUserId) {
          await supabase
            .from("user_estates")
            .update({ relationship_to_decedent: relationshipValue })
            .eq("user_id", authUserId)
            .eq("estate_id", deceasedUserId);
        }
      }
    },
    [authUserId, deceasedUserId, saveRegularSSN, savePassportNumber],
  );
}
